<template>

	<ul class="page-breadcrumb">

		<li>
			<i class="icon-home" aria-hidden="true"></i>
			<span v-translate>Home</span>
			<i class="fa fa-angle-right" aria-hidden="true" v-if="pages"></i>
		</li>

		<li v-for="(page, index) in pages">
			<a v-if="page.link" v-bind:href="page.link">{{ page.text }}</a>
			<span v-if="!page.link">{{ page.text }}</span>
			<i class="fa fa-angle-right" aria-hidden="true" v-if="index !== pages.length - 1"></i>
		</li>

	</ul>

</template>

<script>

	import Breadcrumb from './';
	export default Breadcrumb;

</script>



// WEBPACK FOOTER //
// breadcrumb.vue?0ddbc959